import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivityModel, BusinessUnitModel, EActivityContentType, TopicModel, UserModel} from '../../@models';
import {ApiService} from '../../@core/service/api.service';
import {Observable, Subscription} from 'rxjs';
import {SidebarCommon} from '../../@core/common/sidebar';
import {ActivatedRoute, Router} from '@angular/router';
import { DownloadType } from '../../@models/erp/baseProduct';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { NbDialogService } from '@nebular/theme';
import { HtmlContainerComponent } from '../shared/html-container/html-container.component';

@Component({
  selector: 'ngx-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})

export class NewsComponent extends SidebarCommon<ActivityModel> implements OnInit, OnDestroy {

  news: Observable<ActivityModel[]>;
  businessUnits: BusinessUnitModel[];
  businessUnitsSubscription: Subscription;

  search: string;

  backLink: string = null;
  isPreview = false;

  public ActivityContentType = EActivityContentType;

  downloadType = DownloadType;

  user: UserModel;

  constructor(
    private api: ApiService,
    private auth: AuthGuardService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: NbDialogService,
  ) {
    super()
  }

  ngOnInit() {
    this.user = this.auth.user;

    const activityId = this.route.snapshot.paramMap.get('activity');
    if (activityId != null) {
      this.api.loadActivity(activityId)
        .subscribe(activity => this.toggleSidebarDetail(activity));
    }

    this.news = this.api.reloadNews();
    this.businessUnitsSubscription = this.api.reloadBusinessUnits().subscribe(bu => {
      this.businessUnits = bu;
    })
    this.backLink = this.route.snapshot.queryParams.back;
  }

  ngOnDestroy(): void {
    this.businessUnitsSubscription.unsubscribe();
  }

  cancel() {
    if (this.backLink != null) {
      this.router.navigate(this.backLink.split('/'))
    } else {
      this.hideSidebar();
    }
  }

  save(item: ActivityModel) {
  }

  getActivityType(value: number): string {
    return EActivityContentType[value];
  }


  filterBusinessUnits(selected: ActivityModel, topics: TopicModel[], bu: string): TopicModel[] {
    return topics?.filter(
      t => String(
        (selected.business.projects.find(x => x._id === t.project) || {businessUnit: null}).businessUnit)
        === String(bu));
  }

  getProjectName(item: ActivityModel, id: string): string {
    if (item == null || item.business == null || item.business.projects == null) return '';
    const r = item.business.projects.find(x => x._id === id);
    return r != null ? r.name : '';
  }

  filter(search: string, activities: ActivityModel[]) {
    if (search == null || search.length === 0) return activities;
    const s = search.toLowerCase();
    return activities.filter(x =>
      (x.location || '').toLowerCase().includes(s) ||
      (x.purpose || '').toLowerCase().includes(s) ||
      ((x.business || {name: null}).name || '').toLowerCase().includes(s) ||
      ((x.owner || {name: null}).name || '').toLowerCase().includes(s) ||
      (x.title || '').toLowerCase().includes(s));
  }

  async openVR(item: ActivityModel) {
    return await this.api.downloadVisitReport(item || this.selected);
  }

  async pdfPreview(item: ActivityModel, downloadType: DownloadType) {
    // console.log('download type', DownloadType[downloadType]);
    if (downloadType === DownloadType.pdfAndZip) {
      this.api.downloadVisitReport(item, DownloadType.document);
      this.api.downloadVisitReport(item, DownloadType.zipAttachments);
    } else if (downloadType === DownloadType.preview) {
      const data = await this.api.downloadVisitReport(item, downloadType);
      this.dialog.open(HtmlContainerComponent, {
        context: {
          html: data?.html,
          okText: 'Download',
        }
      }).onClose.subscribe(response => {
        if (response.ok) {
          this.api.downloadVisitReport(item, DownloadType.document);
        }
      })
    } else {
      this.api.downloadVisitReport(item, downloadType);
    }
  }

  isNoteOrVRorOM() {
    return this.selected?.content?.type === EActivityContentType.VisitReport 
      || this.selected?.content?.type === EActivityContentType.Note
      || this.selected?.content?.type === EActivityContentType.OnlineMeeting
      || this.selected?.content?.type === EActivityContentType.TradeShowMeeting
      || this.selected?.content?.type === EActivityContentType.OnSiteMeeting;
  }

  showMergeOrZipButton() {
    return this.selected?.pdfs?.filter(f => f.checked)?.length;
  }

  edit(newVersion = false) {
    this.router.navigate(['/pages/activity'], { queryParams:
      newVersion ? { newVersion: this.selected._id } : { edit: this.selected._id },
    });
  }

  canEdit() {
    return this.selected?.business?.manager === this.user?.contact || this.selected?.owner?._id === this.user?._id
  }

}
